import { PagedQuestionnaireWrapper } from 'features/patient/assessment/_components/questionnaire-paginator';
import { QUESTIONNAIRE_TITLE_24_HR } from '../../_components/questionnaire-paginator-types';
import {
  DhiSliceReducer,
  initialState,
  submit,
  updateDhiItem,
  validate
} from './dhiSlice';
import { formatDhi } from './PatientDhi';

export function PaginationCombined(props: { storageKey: string }) {
  return (
    <PagedQuestionnaireWrapper
      actions={{
        formatData: formatDhi,
        validate,
        updateItem: updateDhiItem as any,
        submit
      }}
      initialState={initialState}
      reducer={DhiSliceReducer}
      getData={state => state.dhi}
      storageKey={props.storageKey}
      pageTitle={QUESTIONNAIRE_TITLE_24_HR}
    />
  );
}
